import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-ivory" data-id="element-103" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-104" data-mp="223eltma3nb3z">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-cream border border-gold/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-105" data-mp="222dbjk0wqsnb">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-106" data-mp="14g65s6svau9d" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-brand text-gold mb-8" data-id="element-107" data-mp="1j52du3uxc79z">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-108" data-mp="1ecsr0wp3vnbx" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-brand" data-id="element-109" data-mp="qnzqemxjgraz">
            🛡️ Complete 7-Day Money-Back Guarantee
          </h2>
          <div className="space-y-6 text-lg text-ink/80 max-w-2xl mx-auto" data-id="element-110" data-mp="lon2rzyufg7c">
            <p data-id="element-111" data-mp="oygnqkxvvodg">
              Open the entire 6-in-1 teaching system. Explore all the bonuses. Use the material in your most challenging
              lesson this week.
            </p>
            <p className="font-medium text-brand" data-id="element-112" data-mp="yp2vjszczall">
              If you feel the material is not clear, practical or useful for your teaching needs, contact us within 7
              days.
            </p>
            <p className="text-gold-dark font-bold text-xl" data-id="element-113" data-mp="61fhkwslfi7x">
              We will refund 100% of your money. No questions. No forms. No complications.
            </p>
            <p className="text-sm text-mist-text mt-8" data-id="element-114" data-mp="f1bz8egkfgth">
              Because if the material does not deliver the value we promise, we do not want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}